import { render, staticRenderFns } from "./ExchangeAcceptPopup.vue?vue&type=template&id=2bc01ca2&scoped=true&"
import script from "./ExchangeAcceptPopup.vue?vue&type=script&lang=ts&"
export * from "./ExchangeAcceptPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ExchangeAcceptPopup.vue?vue&type=style&index=0&id=2bc01ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc01ca2",
  null
  
)

export default component.exports